import { GET_TELE_RECORDINGS_V2 } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface TeleRecordingResponse {
    success: boolean;
    urls?: string[];
    error?: string;
}

export default async (recordingIds: string[]): Promise<TeleRecordingResponse> => {
    return fetchWithRefresh(GET_TELE_RECORDINGS_V2(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ recordingIds }),
    }).then(async (res) => {
        if (res.status === 200) {
            return await res.json();
        } else {
            return await res.json().then((errorData) => ({
                success: false,
                error: errorData.error || 'Failed to fetch recordings',
            }));
        }
    });
};
